<template>
  <v-row no-gutters class="py-3">
    <v-col cols="auto" align-self="center">
      <v-btn
        color="primary"
        @click="$emit('openDialog', rowName)"
        v-if="!isFetching"
        min-width="26px"
        :height="26"
        class="pa-0 rounded-lg"
      >
        <v-icon style="font-size: 18px;"> mdi-cached </v-icon>
      </v-btn>
      <main-loader v-else></main-loader>
    </v-col>
    <v-col cols="8" class="text-left ml-2">
      <v-row no-gutters>
        <v-col> {{ $i18n.t('admin.generatedDate') }}: {{ dateText }} </v-col>
      </v-row>
      <v-row no-gutters>
        <v-col>
          <italic-subheader translation-path="admin.layersAttributesSubtitle"></italic-subheader>
        </v-col>
      </v-row>
    </v-col>
  </v-row>
</template>

<script>
import MainLoader from '@/components/MainLoader';
import ItalicSubheader from '@/components/ItalicSubheader';

export default {
  name: 'MobileAppLayersRow',
  components: { MainLoader, ItalicSubheader },
  props: {
    rowName: {
      type: String,
      required: true,
    },
    date: {
      type: String,
      default: '',
    },
    isFetching: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    dateText() {
      if (!this.date) {
        return this.$i18n.t('admin.noData');
      } else {
        return this.$dayjs(this.date).format('L, LTS');
      }
    },
  },
};
</script>

<style scoped lang="scss"></style>
